import { fetcher } from '@commenda/utils';
import type { UpdateAdminInternalCustomerContextDocumentParams } from './types';

export const updateAdminInternalCustomerContextDocument = (
  companyId: number,
  body: Readonly<UpdateAdminInternalCustomerContextDocumentParams>
): Promise<Response> =>
  fetcher(`admin/companies/${companyId}/context`, { method: 'PUT', body });
